var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "uk-grid-collapse uk-flex-middle uk-position-relative wow-payin__edit-item",
      attrs: { "uk-grid": "" },
    },
    [
      _vm.loading === true
        ? _c("div", { staticClass: "wow-payin__loading" }, [
            _c("div", { attrs: { "uk-spinner": "" } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wow-payin__btn-center uk-width-1-4@m uk-width-1-6@l" },
        [
          _c(
            "div",
            { staticClass: "uk-padding-small" },
            [
              _c("image-upload", {
                ref: "imageFile",
                attrs: {
                  "field-name": "image-upload",
                  "data-wow-att": "wow-payin-edit-file-upload",
                  "init-value":
                    _vm.payment.payment_documentname &&
                    _vm.payment.payment_documentname[0]
                      ? "" +
                        _vm.payment.payment_pathdocument +
                        _vm.payment.payment_documentname[0]
                      : "",
                  "handle-upload-image": _vm.handleUploadImage,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "uk-width-expand@m" }, [
        _c(
          "table",
          { staticClass: "wow-payin__add_payin uk-table uk-margin-remove" },
          [
            _c("tr", [
              _c("td", [_vm._v("ยอดที่ชำระ :")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.paymentEdit.paid_amount,
                      expression: "paymentEdit.paid_amount",
                    },
                  ],
                  staticClass: "uk-input",
                  class: {
                    "uk-form-danger": _vm.formErrors.paid_amount == true,
                  },
                  attrs: { type: "number" },
                  domProps: { value: _vm.paymentEdit.paid_amount },
                  on: {
                    keyup: _vm.handleUpdateInput,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.paymentEdit,
                        "paid_amount",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "uk-visible@m" }, [_vm._v("บาท")]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("vue-ctk-date-time-picker", {
                    class: {
                      "has-error": this.formErrors.paid_datetime === true,
                    },
                    attrs: {
                      label: "วันที่ชำระเงิน",
                      format: "YYYY-MM-DD HH:mm:ss",
                      formatted: "lll",
                      color: "black",
                      buttonColor: "black",
                    },
                    model: {
                      value: _vm.datePaymentEdit,
                      callback: function ($$v) {
                        _vm.datePaymentEdit = $$v
                      },
                      expression: "datePaymentEdit",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n                    ช่องทางการชำระเงิน :\n                "
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.paymentEdit.channel,
                      expression: "paymentEdit.channel",
                    },
                  ],
                  staticClass: "uk-input",
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.paymentEdit.channel },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.paymentEdit, "channel", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("หมายเหตุ :")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.paymentEdit.remark,
                      expression: "paymentEdit.remark",
                    },
                  ],
                  staticClass: "uk-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.paymentEdit.remark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.paymentEdit, "remark", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "uk-width-auto@m" }, [
        _c("div", { staticClass: "uk-text-center wow-payin__edit-action" }, [
          _c(
            "button",
            {
              staticClass:
                "uk-button uk-width-1-1 uk-button-primary wow-payin__button_update",
              on: {
                click: function ($event) {
                  return _vm.updatePayment()
                },
              },
            },
            [_vm._v("บันทึก")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "uk-button uk-width-1-1 wow-payin__button_cancel",
              on: {
                click: function ($event) {
                  return _vm.handleCancelEditPayment(
                    _vm.payment.payment_paidbyid
                  )
                },
              },
            },
            [_vm._v("ยกเลิก")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _vm._v("\n                    วันที่ชำระเงิน : "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "uk-text-small" }, [_vm._v("(dd/mm/yyyy)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }